import enUS from './en-US/en-US';
import zhCN from './zh-CN/zh-CN';
import jaJP from './ja-JP/ja-JP';
import koKR from './ko-KR/ko-KR';

const AllLocales = {
    'en-US':enUS,
    'zh-CN':zhCN,
    'ja-JP':jaJP,
	'ko-KR':koKR
}

export {
    enUS,
    zhCN,
    jaJP,
	koKR,
    AllLocales
}